/* eslint-disable */
const state = {
  brand: null,
  type: null,
  model: null,
  color: null,
  laborer: null,
  laborerType: null,
  supplier: null,
  customer: null,
  sparepart: null,
  sparepartVariant: null,
  sparepartSizes : null,
  sparepartAttachments : null,
  woSteps: null,
  month: null,
  year: null,
  insuranceType :null
}

const getters = {
  //get Sparepart Sizes
  getSparepartSizes : (state) => {
    return state.sparepartSizes
  },
  // Sparepart Attachments
  getSparepartAttachments : (state) => {
    return state.sparepartAttachments
  },
  //Brand
  getBrand : (state) => {
    return state.brand
  },

  //Type
  getType : (state) => {
    return state.type
  },

  //Model
  getModel : (state) => (brand) => {
    if(brand == null || brand.length == 0) return state.model
    let brands = brand.map(a => a.name);
    return state.model.filter((singleModel) => { return brands.indexOf(singleModel.brand_name) !== -1 })
  },
  getSingleModelId : (state) => (brand) => {
    if(brand == null || brand == '') return state.model
    return state.model.filter(singleModel => singleModel.brand_id == brand)
  },
  getModelDetailById : (state) => (id) => {
    return state.model.find(singleModel => singleModel.id == id)
  },

  //Color
  getColor : (state) => {
    return state.color
  },

  //Laborer
  getLaborer : (state) => {
    return state.laborer
  },

  //Laborer
  getLaborerById : (state) => (id) => {
    let result = state.laborer.filter(x=>x.id==id)
    return result.length>0 ? result[0] : null
  },

  //Laborer Type
  getLaborerType : (state) => {
    return state.laborerType
  },

  //Supplier
  getSupplier : (state) => {
    return state.supplier
  },
  getSupplierNameById : (state) => (supplierId) => {
    return state.supplier.filter(x=>x.id==supplierId)[0].name
  },

  //get Insurance Type

  getInsuranceType : (state) => {
    return state.insuranceType
  },

  //Customer
  getCustomer : (state) => {
    return state.customer
  },

  // Sparepart
  getSparepart : (state) => (brand_id, sparepart_type) => {
    if(
      (brand_id == null || (typeof brand_id != 'string' && brand_id.length == 0)) &&
      (sparepart_type == null || (typeof sparepart_type != 'string' && sparepart_type.length == 0))
    ) return state.sparepart

    var brand_ids = []
    var sparepart_types = []
    var compiledStr = ""

    //Array of 'brand_id' strings or a string of 'brand_id'
    if (brand_id != null && (typeof brand_id == 'number' || brand_id.length > 0)){
      brand_ids = typeof brand_id == 'number' ? [brand_id] : brand_id
      compiledStr += "brand_ids.indexOf(singleSparepart.sparepart_brand_id) !== -1 &&"
    }

    //Array of 'sparepart_type' strings or a string of 'sparepart_type'
    if(sparepart_type != null && (typeof sparepart_type == 'string' || sparepart_type.length > 0)){
      sparepart_types = typeof sparepart_type == 'string' ? [sparepart_type] : sparepart_type
      compiledStr += "sparepart_types.indexOf(singleSparepart.sparepart_variants.sparepart_type.name) !== -1 &&"
    }

    if(compiledStr != "") compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";
    compiledStr = "state.sparepart.filter((singleSparepart) => { return " + compiledStr;

    return eval(compiledStr)
  },
  getSparepartById : (state) => (id) => {
    let result = state.sparepart.filter(x=>x.id==id)
    return result.length>0 ? result[0] : null
  },
  getSingleSparepartId : (state) => (brand_id) => {
    if(side == null || side == '') return state.sparepart
    return state.sparepart.filter(singleSparepart => singleSparepart.sparepart_side_id == side)
  },

  getSparepartVariant : (state) => (type) => {
    if(
      (type == null || (typeof type != 'string' && type.length == 0))
    ) return state.sparepartVariant

    var types = []
    var compiledStr = ""

    //Array of 'type' strings or a string of 'type'
    if (type != null && (typeof type == 'string' || type.length > 0)){
      types = typeof type == 'string' ? [type] : type
      compiledStr += "types.indexOf(singleSparepartVariant.sparepart_type.name) !== -1 &&"
    }

    if(compiledStr != "") compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";
    compiledStr = "state.sparepartVariant.filter((singleSparepartVariant) => { return " + compiledStr;

    return eval(compiledStr)
  },

  //Work Order Steps
  getWoSteps : (state) => {
    return state.woSteps
  },

  getMonth : (state) => {
    return state.month
  },
  getYear : (state) => {
    return state.year
  },
  // getCodeMarket : (state) => (category, segment, subSeries, type) => {
  //   if(
  //     (category == null || category.length == 0) &&
  //     (segment == null || segment.length == 0) &&
  //     (subSeries == null || subSeries.length == 0) &&
  //     (type == null || type.length == 0)
  //   ) return state.codeMarket

  //   var counter = 0;
  //   var categories = []
  //   var segments = []
  //   var subSerieses = []
  //   var types = []
  //   var compiledStr = "state.codeMarket.filter((singleCodeMarket) => { return "

  //   if (category != null && category.length > 0){
  //     categories = category.map(a => a.category)
  //     compiledStr += "categories.indexOf(singleCodeMarket.category) !== -1 &&"
  //     counter++;
  //   }

  //   if(segment != null && segment.length > 0){
  //     segments = segment.map(a => a.segment)
  //     compiledStr += "segments.indexOf(singleCodeMarket.segment) !== -1 &&"
  //     counter++;
  //   }

  //   if(subSeries != null && subSeries.length > 0){
  //     subSerieses = subSeries.map(a => a.subseries)
  //     compiledStr += "subSerieses.indexOf(singleCodeMarket.subseries) !== -1 &&"
  //     counter++;
  //   }

  //   if(type != null && type.length > 0){
  //     types = type.map(a => a.type)
  //     compiledStr += "types.indexOf(singleCodeMarket.type) !== -1 &&"
  //     counter++;
  //   }

  //   if(counter != 0) compiledStr = compiledStr.slice(0, compiledStr.length-3) + " })";

  //   return eval(compiledStr)
  // },
  getFilterOptions : (state) => {
    const filterOptions = Object.assign({} , state)
    return filterOptions
  }
}

const mutations = {
  sparepartAttachmentsStatus (state , sparepartAttachments) {
    // console.log(sparepartAttachments)
    if(sparepartAttachments){
      state.sparepartAttachments = sparepartAttachments;
      console.log(state.sparepartAttachments)
    } else {
      delete state.sparepartAttachments
    }
  },
  sparepartSizesStatus (state , sparepartSizes) {
    if(sparepartSizes){
      state.sparepartSizes = sparepartSizes;
    } else {
      delete state.sparepartSizes
    }
  },
  brandStatus (state, brand) {
    if(brand){
      state.brand = brand;
    } else {
      delete state.brand
    }
  },
  typeStatus (state, type) {
    if(type){
      state.type = type;
    } else {
      delete state.type
    }
  },
  modelStatus (state, model) {
    if(model){
      state.model = model;
    } else {
      delete state.model
    }
  },
  colorStatus (state, color) {
    if(color){
      state.color = color;
    } else {
      delete state.color
    }
  },
  laborerStatus (state, laborer) {
    if(laborer){
      state.laborer = laborer;
    } else {
      delete state.laborer
    }
  },
  insuranceTypeStatus (state, insuranceType) {
    if(insuranceType){
      state.insuranceType = insuranceType;
    } else {
      delete state.insuranceType
    }
  },
  laborerTypeStatus (state, laborerType) {
    if(laborerType){
      state.laborerType = laborerType;
    } else {
      delete state.laborerType
    }
  },
  supplierStatus (state, supplier) {
    if(supplier){
      state.supplier = supplier;
    } else {
      delete state.supplier
    }
  },
  customerStatus (state, customer) {
    if(customer){
      state.customer = customer;
    } else {
      delete state.customer
    }
  },
  sparepartStatus (state, sparepart) {
    if(sparepart){
      state.sparepart = sparepart;
    } else {
      delete state.sparepart
    }
  },
  sparepartVariantStatus (state, sparepartVariant) {
    if(sparepartVariant){
      state.sparepartVariant = sparepartVariant;
    } else {
      delete state.sparepartVariant
    }
  },
  woStepsStatus (state, woSteps) {
    if(woSteps){
      state.woSteps = woSteps;
    } else {
      delete state.woSteps;
    }
  },
  monthStatus (state, month){
      if(month){
        state.month = month;
      } else {
        delete state.month
      }
  },
  yearStatus (state, year) {
    if(year){
      state.year = year;
    } else {
      delete state.year
    }
  },
  filterOptionsStatus (state, filterOptions){
    if(filterOptions){
      state.brand = (filterOptions['brand'] != null) ? filterOptions['brand'] : null;
      state.type = (filterOptions['type'] != null) ? filterOptions['type'] : null;
      state.model = (filterOptions['model'] != null) ? filterOptions['model'] : null;
      state.color = (filterOptions['color'] != null) ? filterOptions['color'] : null;
      state.laborer = (filterOptions['laborer'] != null) ? filterOptions['laborer'] : null;
      state.laborerType = (filterOptions['laborerType'] != null) ? filterOptions['laborerType'] : null;
      state.supplier = (filterOptions['supplier'] != null) ? filterOptions['supplier'] : null;
      state.customer = (filterOptions['customer'] != null) ? filterOptions['customer'] : null;
      state.sparepart = (filterOptions['sparepart'] != null) ? filterOptions['sparepart'] : null;
      state.sparepartVariant = (filterOptions['sparepartVariant'] != null) ? filterOptions['sparepartVariant'] : null;
      state.woSteps = (filterOptions['woSteps'] != null) ? filterOptions['woSteps'] : null;
      state.month = (filterOptions['month'] != null) ? filterOptions['month'] : null;
      state.year = (filterOptions['year'] != null) ? filterOptions['year'] : null;
      state.insuranceType = (filterOptions['insuranceType'] != null) ? filterOptions['insuranceType'] : null;
      state.sparepartSizes = (filterOptions['sparepartSizes'] != null) ? filterOptions['sparepartSizes'] : null;
      state.sparepartAttachments = (filterOptions['sparepartAttachments'] != null) ? filterOptions['sparepartAttachments'] : null;
    } else {
      delete state.brand
      delete state.type
      delete state.model
      delete state.color
      delete state.laborer
      delete state.laborerType
      delete state.supplier
      delete state.customer
      delete state.sparepart
      delete state.sparepartVariant
      delete state.woSteps
      delete state.month
      delete state.year
      delete state.insuranceType
      delete state.sparepartAttachments
      delete state.sparepartSizes
    }
  }
}

const actions = {
  setSparepartSizes ({ commit }, sparepartSizes){
    commit('sparepartSizesStatus', sparepartSizes);
  },
  setSparepartAttachments ({ commit }, sparepartAttachments){
    commit('sparepartAttachmentsStatus', sparepartAttachments);
  },
  setBrand ({ commit }, brand){
    commit('brandStatus', brand);
  },
  setType ({ commit }, type){
    commit('typeStatus', type);
  },
  setModel ({ commit }, model){
    commit('modelStatus', model);
  },
  setColor ({ commit }, color){
    commit('colorStatus', color);
  },
  setLaborer ({ commit }, laborer){
    commit('laborerStatus', laborer);
  },
  setLaborerType ({ commit }, laborerType){
    commit('laborerTypeStatus', laborerType);
  },
  setSupplier ({ commit }, supplier){
    commit('supplierStatus', supplier);
  },
  setCustomer ({ commit }, customer){
    commit('customerStatus', customer);
  },
  setSparepart({ commit }, sparepart){
    commit('sparepartStatus', sparepart);
  },
  setSparepartVariant({ commit }, sparepartVariant){
    commit('sparepartVariantStatus', sparepartVariant);
  },
  setMonth ({ commit }, month){
    commit('monthStatus', month);
  },
  setWoSteps({ commit }, woSteps){
    commit('woStepsStatus', woSteps);
  },
  setYear ({ commit }, year){
    commit('yearStatus', year);
  },
  setFilterOptions ({ commit }, filterOptions){
    commit('filterOptionsStatus', filterOptions);
  },
  setInsuranceType ({ commit }, filterOptions) {
    commit('insuranceTypeStatus' , filterOptions)
  }
}

export default{
  state,
  getters,
  mutations,
  actions
}